import { concatMap, map, from, mergeMap, zip, of, toArray } from 'rxjs';
import { CrudServiceBase } from '@utils';
import { ParkArea } from './park-area.class';
import { ParkAreaAssesmentService } from '@services/park-area-assesment';

export class ParkAreaService extends CrudServiceBase<ParkArea> {
	constructor(siteId: string) {
		super(ParkArea, `site/${siteId}/park-area`);
	}

	getAllWithAssesments(assesmentId?: string) {
		return super.getAll().pipe(
			concatMap((result) => from(result)),
			mergeMap((parkArea) =>
				zip(of(parkArea), assesmentId ? new ParkAreaAssesmentService(parkArea.id).getByAssesmentId(assesmentId) : of(undefined))
			),
			map(([parkArea, assesment]) => parkArea.setAssesment(assesment)),
			toArray()
		);
	}
}
